"use strict";
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");

var AbstractViewerController = require("./../../abstractViewerController.js");

var PathViewerStateMachine = require("./pathViewerStateMachine.js");
var PathInteractionView = require("./pathInteractionView.js");
var PathInteractionModel = require("./pathInteractionModel.js");
var PathArcSegmentModel = require("./pathArcSegmentModel");
var ArcCenterHandleModel = require("./arcCenterHandleModel");

var PathViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);

    // Define possible GUI events
    lib_core.GuiEvents.addEvents({
        PATH_SMOOTH_BEZIER_CONVERT:            {id: 'pth_1', name: "PATH_SMOOTH_BEZIER_CONVERT"               }
    });
};
lib_core.inherit(PathViewerController, AbstractViewerController);
PathViewerController.inject = lib_core.clone(editor_2d.AbstractViewerController.inject);
PathViewerController.inject['snapController'] = editor_2d.SnapController;

module.exports = PathViewerController;

PathViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
    if(this.snapController) {
        this.snapController.getModel().rules.push({
            fromClass  : Object,
            fromPath   : null,
            fromKey    : /.*/,
            toClass    : PathArcSegmentModel,
            toPath     : null,
            toKey      : "ArcSegmentSegment",
            condition  : function(from, to) {
                return from.parent
                    && from.parent instanceof ArcCenterHandleModel
                    && from.parent.segmentModel === to.parent;
            },
            priority   : 1
        }, {
            fromClass  : Object,
            fromPath   : null,
            fromKey    : /.*/,
            toClass    : PathArcSegmentModel,
            toPath     : null,
            toKey      : "ArcSegmentMidline",
            condition  : function(from, to) {
                return from.parent
                    && from.parent instanceof ArcCenterHandleModel
                    && from.parent.segmentModel === to.parent;
            },
            priority   : 1
        });
    }
};

PathViewerController.prototype.getDataType = function () {
    return cio_datamodel.PathData;
};

PathViewerController.prototype.getInteractionViewType = function () {
    return PathInteractionView;
};

PathViewerController.prototype.getInteractionModelType = function () {
    return PathInteractionModel;
};

PathViewerController.prototype.createStateMachine = function () {
    return new PathViewerStateMachine(this.root, this.getModel());
};
